var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container"},[_c('meeting-room-setting-form',{attrs:{"items":_vm.rooms},on:{"save":_vm.saveRooms}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }